import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const PID_KEY = "pulsementi_participant_id";
export function getParticipantId() {
  let id = localStorage.getItem(PID_KEY);
  if (!id) {
    id = "p_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(PID_KEY, id);
  }
  return id;
}

const NICK_KEY = "pulsementi_nickname";
export function getNickname() {
  return localStorage.getItem(NICK_KEY) || "";
}
export function setNickname(name) {
  localStorage.setItem(NICK_KEY, name);
}
